import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
// استيراد صور الملابس الحريمي
import img1 from '../img/woman (1).jpeg';
import img2 from '../img/woman (2).jpeg';
import img3 from '../img/woman (3).jpeg';
import img4 from '../img/woman (4).jpeg';
import img5 from '../img/woman (5).jpeg';
import img6 from '../img/woman (6).jpeg';
import img7 from '../img/woman (7).jpeg';
import img8 from '../img/woman (8).jpeg';
import img9 from '../img/woman (9).jpeg';
import img10 from '../img/woman (10).jpeg';
import img11 from '../img/woman (11).jpeg';
import img12 from '../img/woman (12).jpeg';
import img13 from '../img/woman (13).jpeg';
import img14 from '../img/woman (14).jpeg';
import img15 from '../img/woman (15).jpeg';
import img16 from '../img/woman (16).jpeg';
import img17 from '../img/woman (17).jpeg';
import img18 from '../img/woman (18).jpeg';
import img19 from '../img/woman (19).jpeg';
import img20 from '../img/woman (20).jpeg';
import img21 from '../img/woman (21).jpeg';
import img22 from '../img/woman (22).jpeg';
import img23 from '../img/woman (23).jpeg';
import img24 from '../img/woman (24).jpeg';
import img25 from '../img/woman (25).jpeg';
import img26 from '../img/woman (26).jpeg';
import img27 from '../img/woman (27).jpeg';
import img28 from '../img/woman (28).jpeg';
import img29 from '../img/woman (29).jpeg';
import img30 from '../img/woman (30).jpeg';
import img31 from '../img/woman (31).jpeg';
import img32 from '../img/woman (32).jpeg';
import img33 from '../img/woman (33).jpeg';
import img34 from '../img/woman (34).jpeg';
import img35 from '../img/woman (35).jpeg';
import img36 from '../img/woman (36).jpeg';
import img37 from '../img/woman (37).jpeg';
import img38 from '../img/woman (38).jpeg';
import img39 from '../img/woman (39).jpeg';
import img40 from '../img/woman (40).jpeg';
import img41 from '../img/woman (41).jpeg';
import img61 from '../img/kids (1).jpeg';
import img62 from '../img/kids (2).jpeg';
import img63 from '../img/kids (3).jpeg';
import img64 from '../img/kids (4).jpeg';
import img65 from '../img/kids (5).jpeg';
import img66 from '../img/kids (6).jpeg';
import img67 from '../img/kids (7).jpeg';
import img68 from '../img/kids (8).jpeg';
import img69 from '../img/kids (9).jpeg';
import img70 from '../img/kids (10).jpeg';

import img900 from '../img/logo.png';

const categoriesData = [
  {
    id: 'men',
    title: 'الملابس الرجالي',
    coverImg: img900,
    products: [
      { id: 101, title: 'انتظرو الكولكشن الشتوي', img: img900 },
      { id: 102, title: 'انتظرو الكولكشن الشتوي', img: img900 },
      { id: 103, title: ' انتظرو الكولكشن الشتوي', img: img900 },
      { id: 104, title: 'انتظرو الكولكشن الشتوي  ', img: img900 },
      { id: 105, title: ' انتظرو الكولكشن الشتوي ', img: img900 },
      { id: 106, title: 'انتظرو الكولكشن الشتوي ', img: img900 },
      { id: 110, title: 'انتظرو الكولكشن الشتوي ', img: img900 },
    ]
  },
  {
    id: 'women',
    title: 'الملابس الحريمي',
    coverImg: img1,
    products: [
      { id: 201, title: 'موديل حريمي 1', img: img1 },
      { id: 202, title: 'موديل حريمي 2', img: img2 },
      { id: 203, title: 'موديل حريمي 3', img: img3 },
      { id: 204, title: 'موديل حريمي 4', img: img4 },
      { id: 205, title: 'موديل حريمي 5', img: img5 },
      { id: 206, title: 'موديل حريمي 6', img: img6 },
      { id: 207, title: 'موديل حريمي 7', img: img7 },
      { id: 208, title: 'موديل حريمي 8', img: img8 },
      { id: 209, title: 'موديل حريمي 9', img: img9 },
      { id: 210, title: 'موديل حريمي 10', img: img10 },
      { id: 211, title: 'موديل حريمي 11', img: img11 },
      { id: 212, title: 'موديل حريمي 12', img: img12 },
      { id: 213, title: 'موديل حريمي 13', img: img13 },
      { id: 214, title: 'موديل حريمي 14', img: img14 },
      { id: 215, title: 'موديل حريمي 15', img: img15 },
      { id: 216, title: 'موديل حريمي 16', img: img16 },
      { id: 217, title: 'موديل حريمي 17', img: img17 },
      { id: 218, title: 'موديل حريمي 18', img: img18 },
      { id: 219, title: 'موديل حريمي 19', img: img19 },
      { id: 220, title: 'موديل حريمي 20', img: img20 },
      { id: 221, title: 'موديل حريمي 21', img: img21 },
      { id: 222, title: 'موديل حريمي 22', img: img22 },
      { id: 223, title: 'موديل حريمي 23', img: img23 },
      { id: 224, title: 'موديل حريمي 24', img: img24 },
      { id: 225, title: 'موديل حريمي 25', img: img25 },
      { id: 226, title: 'موديل حريمي 26', img: img26 },
      { id: 227, title: 'موديل حريمي 27', img: img27 },
      { id: 228, title: 'موديل حريمي 28', img: img28 },
      { id: 229, title: 'موديل حريمي 29', img: img29 },
      { id: 230, title: 'موديل حريمي 30', img: img30 },
      { id: 231, title: 'موديل حريمي 31', img: img31 },
      { id: 232, title: 'موديل حريمي 32', img: img32 },
      { id: 233, title: 'موديل حريمي 33', img: img33 },
      { id: 234, title: 'موديل حريمي 34', img: img34 },
      { id: 235, title: 'موديل حريمي 35', img: img35 },
      { id: 236, title: 'موديل حريمي 36', img: img36 },
      { id: 237, title: 'موديل حريمي 37', img: img37 },
      { id: 238, title: 'موديل حريمي 38', img: img38 },
      { id: 239, title: 'موديل حريمي 39', img: img39 },
      { id: 240, title: 'موديل حريمي 40', img: img40 },
      { id: 241, title: 'موديل حريمي 41', img: img41 },
    ]
  },
  {
    id: 'kids',
    title: 'ملابس أطفالي',
    coverImg: img61,
    products: [
      { id: 301, title: 'طقم أطفال صيفي', img: img61 },
      { id: 302, title: 'بيجامة نوم قطن', img: img62 },
      { id: 303, title: 'جاكيت أطفال ملون', img: img68 },
      { id: 304, title: 'طقم أطفال صيفي', img: img63 },
      { id: 305, title: 'بيجامة نوم قطن', img: img64 },
      { id: 306, title: 'جاكيت أطفال ملون', img: img65 },
      { id: 307, title: 'طقم أطفال صيفي', img: img66 },
      { id: 308, title: 'بيجامة نوم قطن', img: img67 },
      { id: 308, title: 'بيجامة نوم قطن', img: img69 },
      { id: 308, title: 'بيجامة نوم قطن', img: img70 },
    ]
  },
];

const PortfolioSection = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [activeImageIndex, setActiveImageIndex] = useState(null);

  const whatsappNumber = "201278922244";

  const handleWhatsAppOrder = (productTitle, e) => {
    e.stopPropagation();
    const message = encodeURIComponent(`مرحباً، أود طلب هذا المنتج: ${productTitle}`);
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };

  const nextImage = (e) => {
    e.stopPropagation();
    if (selectedCategory) {
      setActiveImageIndex((prev) => (prev + 1) % selectedCategory.products.length);
    }
  };

  const prevImage = (e) => {
    e.stopPropagation();
    if (selectedCategory) {
      setActiveImageIndex((prev) => (prev - 1 + selectedCategory.products.length) % selectedCategory.products.length);
    }
  };

  return (
    <section id="portfolio-section" className="portfolio-section">
      <div className="container">
        <h2 className="section-title">
          {selectedCategory ? selectedCategory.title : 'معرض المنتجات'}
        </h2>

        {selectedCategory && (
          <button 
            className="back-btn mb-4" 
            onClick={() => {
              setSelectedCategory(null);
              setActiveImageIndex(null);
            }}
          >
            <i className="fas fa-arrow-right"></i> الرجوع للتصنيفات
          </button>
        )}

        <AnimatePresence mode="wait">
          {!selectedCategory ? (
            <motion.div 
              key="categories"
              className="portfolio-grid"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3 }}
            >
              {categoriesData.map((category, index) => (
                <motion.div
                  key={category.id}
                  className="portfolio-item"
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  onClick={() => setSelectedCategory(category)}
                >
                  <img src={category.coverImg} alt={category.title} />
                  <div className="overlay">
                    <h3>{category.title}</h3>
                    <span className="view-more">تصفح المنتجات <i className="fas fa-long-arrow-alt-left"></i></span>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          ) : (
            <motion.div 
              key="products"
              className="portfolio-grid products-grid"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3 }}
            >
              {selectedCategory.products.map((product, index) => (
                <motion.div
                  key={product.id}
                  className="portfolio-item product-card"
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.4, delay: index * 0.1 }}
                  onClick={() => setActiveImageIndex(index)}
                >
                  <img src={product.img} alt={product.title} />
                  <div className="overlay product-overlay">
                    <h3>{product.title}</h3>
                    <button 
                      className="whatsapp-order-btn"
                      onClick={(e) => handleWhatsAppOrder(product.title, e)}
                    >
                      <i className="fab fa-whatsapp"></i> طلب المنتج عبر واتساب
                    </button>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          )}
        </AnimatePresence>

        {/* نافذة العرض المكبر (Lightbox Modal) */}
        <AnimatePresence>
          {activeImageIndex !== null && selectedCategory && (
            <motion.div 
              className="lightbox-overlay"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setActiveImageIndex(null)}
            >
              <button className="lightbox-close" onClick={() => setActiveImageIndex(null)}>
                <i className="fas fa-times"></i>
              </button>

              <button className="lightbox-nav-btn prev-btn" onClick={prevImage}>
                <i className="fas fa-chevron-right"></i>
              </button>
              
              <button className="lightbox-nav-btn next-btn" onClick={nextImage}>
                <i className="fas fa-chevron-left"></i>
              </button>

              <motion.div 
                className="lightbox-content"
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.8, opacity: 0 }}
                onClick={(e) => e.stopPropagation()}
              >
                <img 
                  src={selectedCategory.products[activeImageIndex].img} 
                  alt={selectedCategory.products[activeImageIndex].title} 
                />
                <div className="lightbox-caption">
                  <h3>{selectedCategory.products[activeImageIndex].title}</h3>
                  <button 
                    className="whatsapp-order-btn lightbox-wa"
                    onClick={(e) => handleWhatsAppOrder(selectedCategory.products[activeImageIndex].title, e)}
                  >
                    <i className="fab fa-whatsapp"></i> اطلب هذا المنتج الآن
                  </button>
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </section>
  );
};

export default PortfolioSection;